import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Loading from "../helpers/loading_component.js";
import "../styles/payments.css";
import { secretKey } from "../.././data";
import emailjs from "@emailjs/browser";

const MySwal = withReactContent(Swal2);

const AddSellFile = (props) => {
  const [loading, setLoading] = useState(false);
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [uploadFilesNamesArrayChanged, setUploadFilesNamesArrayChanged] =
    useState([]);
  const [lead, setLead] = useState("");
  const [inputs, setInputs] = useState({});
  const [user, setUser] = useState([]);
  const [fileType, setFileType] = useState("sell");

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUser(data.filter((el) => el.name === props.owner)[0]);
        fetchClients();
      })
      .catch((error) => {});
  };

  const fetchClients = async () => {
    var body = {
      leadId: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeadsId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLead(data[0]);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = async () => {
    setLoading(true);
    await fetchUsers();
  };

  useEffect(() => {
    getData();
  }, []);

  const changeFiles = (e) => {
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    var check = false;

    Array.from(e.target.files).map((file) => {
      if (file.size > 41943040) {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "plik przekracza 40MB",
        });
        check = true;
      }
    });

    if (check) {
      return;
    }

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  const sendFiles = async (e) => {
    setLoading(true);
    var length = uploadFilesArray.length;
    var progr = 0;
    var userX = "";

    userX = props.tasks
      ? props.tasks.filter((el) =>
          el.task.includes("Skontaktuj się telefonicznie z klientem")
        )[0]
        ? props.tasks.filter((el) =>
            el.task.includes("Skontaktuj się telefonicznie z klientem")
          )[0].responsible
        : props.user
      : props.user;

    uploadFilesArray.map(async (file) => {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", fileType);
      formData.append("leadId", props.id);
      formData.append("user", userX !== "" ? userX : props.user);

      await fetch("https://apidevkppp.ftpeople.pl/uploadSellFile", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.text())
        .then((data) => {
          ++progr;
          MySwal.fire({
            icon: "success",
            title: "Wysłano plik: " + progr + "/" + length,
            text: "",
          }).then(async (result) => {
            if (progr === length) {
              if (!props.uData || !props.user) {
              } else {
                if (props.uData.role === "consultantTele") {
                  var body = {
                    id: props.id,
                  };
                  var url = "";

                  if (
                    lead.type !== "SKD" &&
                    (!lead.owner ||
                      lead.owner === "" ||
                      lead.owner.includes("onsultant"))
                  ) {
                    var url =
                      "https://apidevkppp.ftpeople.pl/setUploadSellConsultant";
                  }

                  if (
                    lead.type === "CHF" &&
                    (!lead.owner ||
                      lead.owner === "" ||
                      lead.owner.includes("onsultant"))
                  ) {
                    var url =
                      "https://apidevkppp.ftpeople.pl/setUploadSellConsultant";
                  }

                  if (
                    lead.type === "SKD" &&
                    (!lead.owner || lead.owner.includes("onsultant")) &&
                    lead.autoAssign !== "1"
                  ) {
                    url =
                      "https://apidevkppp.ftpeople.pl/setUploadSellConsultantSKD";
                  }

                  if (
                    lead.type === "SKD" &&
                    (lead.owner || lead.owner !== "") &&
                    lead.autoAssign === "1"
                  ) {
                  }

                  console.log(url);

                  await fetch(url, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body),
                  })
                    .then((response) => response.text())
                    .then((data) => {
                      return;
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                } else {
                  console.log("asdasd");
                  var body = {
                    id: props.id,
                  };
                  var url = "";

                  if (
                    lead.type === "CHF" &&
                    (!lead.owner ||
                      lead.owner === "" ||
                      lead.owner.includes("onsultant"))
                  ) {
                    var url =
                      "https://apidevkppp.ftpeople.pl/setUploadSellConsultant";
                  }

                  await fetch(url, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body),
                  })
                    .then((response) => response.text())
                    .then((data) => {
                      return;
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                }
              }
              if (
                (user === undefined || user.length === 0) &&
                props.lead.type === "SKD"
              ) {
                MySwal.fire({
                  icon: "success",
                  title: "Dodano",
                  text: "pliki",
                }).then((result) => {
                  props.logClientAction("Dodano pliki do sprawy", props.id);
                  setUploadFiles([]);
                  setUploadFilesArray([]);
                  props.close();
                });
              } else {
                if (
                  props.user !== props.lead.owner ||
                  user.includes("Konsultant")
                ) {
                  emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
                  var templateParams = {
                    to:
                      user === undefined ||
                      user.length === 0 ||
                      user.includes("Konsultant")
                        ? "m.pludowski@kppp.pl"
                        : user.mail.split(",")[0],
                    reply_to: props.userMail,
                    content: `Do sprawy o ID: ${props.id} dodano skany dokumentów`,
                    subject: `Do sprawy o ID: ${props.id} dodano skany dokumentów`,
                    user_name: props.user,
                  };

                  emailjs.send("KPPP", "template_h43760d", templateParams).then(
                    function (response) {
                      MySwal.fire({
                        icon: "success",
                        title: "Dodano",
                        text: "pliki",
                      }).then((result) => {
                        props.logClientAction(
                          "Dodano pliki do sprawy",
                          props.id
                        );
                        setUploadFiles([]);
                        setUploadFilesArray([]);
                        props.close();
                      });
                    },
                    function (error) {
                      props.logClientAction("Dodano pliki do sprawy", props.id);
                      setUploadFiles([]);
                      setUploadFilesArray([]);
                      MySwal.fire({
                        icon: "error",
                        title: "Błąd",
                        text: "nie wysłano wiadomości e-mail. Ponów operację!",
                      }).then(async (result) => {
                        props.close();
                      });
                    }
                  );
                } else {
                  MySwal.fire({
                    icon: "success",
                    title: "Dodano",
                    text: "pliki",
                  }).then((result) => {
                    props.logClientAction("Dodano pliki do sprawy", props.id);
                    setUploadFiles([]);
                    setUploadFilesArray([]);
                    props.close();
                  });
                }
              }
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    });
  };

  return (
    <>
      <div
        style={{ width: "50vw", position: "fixed" }}
        className="mainContainerAddTransaction"
      >
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <>
              <input multiple={true} type="file" onChange={changeFiles} />
              <>
                <div
                  style={{ marginTop: "0", marginBottom: "5vh" }}
                  className="inputBox"
                ></div>
              </>
              <>
                {uploadFilesArray.length > 0 ? (
                  <>
                    <div style={{ maxHeight: "35vh", overflowY: "scroll" }}>
                      <table
                        style={{ width: "100%", boxSizing: "border-box" }}
                        id="detailClientTable"
                        className="clients_table"
                      >
                        <tr>
                          <th>Nazwa pliku</th>
                          <th>Plik</th>
                          <th></th>
                        </tr>
                        {uploadFilesArray.length > 0
                          ? uploadFilesArray.map((el, index) => (
                              <>
                                <tr>
                                  <td
                                    style={{
                                      width: "50%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <div
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      <input
                                        id={"fn" + index}
                                        name={"fn" + index}
                                        style={{
                                          height: "2vh",
                                          marginTop: "0",
                                        }}
                                        type="text"
                                        value={inputs[index]}
                                        onChange={(e) =>
                                          setInputs((prev) => {
                                            return {
                                              ...prev,
                                              [index]: e.target.value,
                                            };
                                          })
                                        }
                                      />
                                      <button
                                        className="refreshButton"
                                        value={index}
                                        onClick={changeFileName}
                                      >
                                        zmień
                                      </button>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "40%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    {el.name}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "10%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <button
                                      className="refreshButton"
                                      value={index}
                                      onClick={deleteTempFile}
                                    >
                                      usuń
                                    </button>
                                  </td>
                                </tr>
                              </>
                            ))
                          : ""}
                      </table>
                    </div>
                    <div style={{ marginTop: "2vh" }}>
                      <button
                        style={{ width: "15%" }}
                        className="refreshButton"
                        onClick={sendFiles}
                      >
                        Wyślij
                      </button>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            </>
          </>
        )}
      </div>
    </>
  );
};

export default AddSellFile;
